"use client";

import React, { useEffect, useRef } from "react";
import { useUser } from "@clerk/nextjs";
import { useSavedListingsMap } from "@/components/listing/SavedListingsProvider";

type Props = {
  listingId: string;
};

const ListingSeenTracker: React.FC<Props> = ({ listingId }) => {
  const { user } = useUser();
  const savedMap = useSavedListingsMap();
  const hasSentRef = useRef(false);
  const isSaved = savedMap?.[listingId] ?? false;

  useEffect(() => {
    if (!user || !isSaved || hasSentRef.current) return;

    hasSentRef.current = true;

    fetch("/api/user/listings/seen", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({ listingId }),
      cache: "no-store",
    }).catch((error) => {
      console.error("Failed to update listing seen count", error);
      hasSentRef.current = false;
    });
  }, [user?.id, isSaved, listingId, user]);

  return null;
};

export default ListingSeenTracker;
